module.exports = __webpack_public_path__ + "static/media/faqs@2x.23add78a.mov";